import React from 'react';

export const DataGridIdentifier = React.createContext<
  { gridId: string } | undefined
>(undefined);
export const DataGridRowIdentifierContext = React.createContext<
  { rowIndex: number } | undefined
>(undefined);

export const DataGridRowIdentifier = ({
  children,
  rowIndex,
}: {
  children: React.ReactNode;
  rowIndex: number;
}) => {
  const value = React.useMemo(() => ({ rowIndex }), [rowIndex]);
  return (
    <DataGridRowIdentifierContext.Provider value={value}>
      {children}
    </DataGridRowIdentifierContext.Provider>
  );
};
